import React, {Fragment} from 'react';
import TextInput from './TextInput';
import Select from './Select';
import isEqual from 'lodash-es/isEqual';
import {set, get} from '../../utils/dotutils';
import classNames from "classnames";
import { loadComponent } from "../../utils/components";
import debounce from "lodash-es/debounce";
import Icon from "./Icon";

class AddressControl extends React.Component {

    state = {
        suggestionCities: []
    }

    constructor(props) {
        super(props);
        this.cityDebounce = debounce((value, setValue = true) => {
            const filter = [{field: "country", value: (this.props.value && this.props.value.country) || 348},{field: "postcode", value}];
            this.loadCity && this.loadCity.abort();
            this.loadCity = loadComponent("componentlist", {
                component: "postcode",
                filter
            });
            this.loadCity.then((data) => {
                this.setState({suggestionCities: []}, () => {
                    if (data.items.length === 1) {
                        if (setValue) {
                            this.setFieldValue("city", data.items[0].city);
                        } else {
                            this.setState({
                                suggestionCities: [data.items[0].city]
                            });
                        }
                    } else if (data.items.length > 1) {
                        this.setState({
                            suggestionCities: data.items.map((item) => item.city)
                        });
                    }
                });
            });
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((this.props.value && this.props.value.postcode) && (this.props.value && this.props.value.postcode) !== (prevProps.value && prevProps.value.postcode)) {
            this.cityDebounce(this.props.value && this.props.value.postcode, false);
        }
    }

    componentDidMount() {
        if (this.props.value && this.props.value.postcode) {
            this.cityDebounce(this.props.value && this.props.value.postcode, false);
        }
    }


    setFieldValue = (field, value) => {
        let oldValue = get(this.props.value, field);
        if (!isEqual(oldValue,value)) {
            const v = Object.assign({},this.props.value);
            set(v, field, value);
            this.props.saveChanges((this.props.name || 'address'), v);
        }
	}

	getLayout = (fields, name) => {
        let style = {};
        if (this.props.label === false) {
            style.display = "none";
        }
        if(name !== '') {
            name += '.';
        }
        const errors = this.props.error || {};
		return <Fragment>
            <div className="col-md-12">
                <label className="control-label" style={style}>{this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}</label>
            </div>
            {fields.indexOf("country") !== -1 && <div className="col-sm-2">
				<Select objectValue={false} required={this.props.required} error={errors.country} disabled={this.props.disabled || false} name={name+"country"} limit={0} isSearchable={true} component="country" labelKey="name" storeType="local" value={ this.props.value && this.props.value.country } saveChanges={ (name, value) => { this.setFieldValue("country", value) } } placeholder="Ország" label={false} />
			</div>}
            {fields.indexOf("postcode") !== -1 && <div className="col-sm-2">
				<TextInput required={this.props.required} error={errors.postcode} disabled={this.props.disabled || false} type="text" name={name+"postcode"} value={ this.props.value && this.props.value.postcode } placeholder="Irányítószám" saveChanges={ (name, value) => {
                    this.setFieldValue("postcode", value);
                    this.cityDebounce(value);
                } } label={false}/>
			</div>}
            {fields.indexOf("city") !== -1 && <div className="col-sm-3">
                <div className={!!this.state.suggestionCities.length && !this.state.suggestionCities.find((city) => (this.props.value && this.props.value.city) === city) && "input-group"}>
                    <TextInput required={this.props.required} error={errors.city} disabled={this.props.disabled || false} name={name+"city"} value={ this.props.value && this.props.value.city } placeholder="Város" saveChanges={ (name, value) => { this.setFieldValue("city", value) } } label={false}/>
                    {!!this.state.suggestionCities.length && !this.state.suggestionCities.find((city) => (this.props.value && this.props.value.city) === city) && <div className="input-group-addon">
                        <Icon lib="fas" name="info-circle" tooltip={<Fragment>Irányítószám alapján javasolt települések:<br/>{this.state.suggestionCities.reduce((items, item) => [...(items || []), item, <br/>], [])}</Fragment>} />
                    </div>}
                </div>
			</div>}
            {fields.indexOf("address") !== -1 && <div className={classNames({"col-sm-5": fields.indexOf("country") !== -1, "col-sm-7": fields.indexOf("country") === -1})}>
				<TextInput required={this.props.required} error={errors.address} disabled={this.props.disabled || false} name={name+"address"} value={ this.props.value && this.props.value.address } placeholder="Utca/Házszám" saveChanges={ (name, value) => { this.setFieldValue("address", value) } } label={false}/>
			</div>}
        </Fragment>;
	}

	render() {
		//console.log("address_render", this.props);
		const default_fields = ['postcode','city','address'];
		const extrafields = this.props.extrafields || [];
		const fields = [...default_fields, ...extrafields];
        let name = this.props.name || 'address';
		return this.props.layout ? this.props.layout(fields, name) : this.getLayout(fields, name);
	}

}

export default AddressControl;